/**
 * HTTPS 页面下将 http 资源地址升级为 https，避免 Mixed Content 被浏览器拦截。
 */
export function ensureHttpsUrl(url) {
  if (!url || typeof url !== 'string') {
    return url
  }
  if (typeof window !== 'undefined' && window.location.protocol === 'https:' && /^http:\/\//i.test(url)) {
    return url.replace(/^http:\/\//i, 'https://')
  }
  return url
}

export function ensureHttpsUrls(urls) {
  if (!Array.isArray(urls)) {
    return []
  }
  return urls.map(ensureHttpsUrl).filter(Boolean)
}
